import { create } from 'zustand'

interface IFontFlowStore {
  isJfsFlow: boolean
  setJfsFlow: (value: boolean) => void
}

export const useFontFlowStore = create<IFontFlowStore>((set) => ({
  isJfsFlow: false,
  setJfsFlow: (value) => set({ isJfsFlow: value }),
}))
